'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import Dashboard from 'Components/Lists/Dashboard';
import PackOrderRow from 'Components/Lists/Rows/AdminPackOrder';
import handleChange from 'Components/Forms/Functions/handleChange';
import Link from 'Pure/Link';
import bemit from 'Functions/bemit';
import { action } from 'Shared/Routes';
import { isTrue } from 'Shared/utilities';
const {
  app
} = window;
const header = [{
  name: 'text_number_order_form',
  label: 'Numéro de commande',
  sortable: false
}, {
  name: 'company.name',
  label: 'Nom de l\'entreprise',
  sortable: false
}, {
  name: 'created_at',
  label: 'Date de commande',
  sortable: false
}, {
  name: 'payment_capture.Date',
  label: 'Date de paiement',
  sortable: false
}, {
  name: 'total_amount_ttc',
  label: 'Montant total TTC',
  sortable: false
}, {
  name: 'payment_type',
  label: 'Type de paiement',
  sortable: false
}, {
  name: 'payment_status',
  label: 'Statut du paiement',
  sortable: false
}, {
  name: 'bill',
  label: 'Facture PDF',
  sortable: false
}, {
  name: 'actions',
  label: '',
  sortable: false
}];
const fields = header.map(infos => infos.name);

// Non-research like client picker, select, date picker, etc
const fields_without_timeout = [];
export default class AdminPackOrdersDashboardPage extends Component {
  state = {
    status_messages: {}
  };
  handleChange = handleChange.bind(this);
  handleSearchChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;

    // Prevent on mount trigger
    if (!e && fields_without_timeout.includes(name) === false) return;
    component.setState({
      [name]: value
    });
    if (fields_without_timeout.includes(name)) return;
    if (component.search_timeout) {
      window.clearTimeout(component.search_timeout);
    }
    component.search_timeout = window.setTimeout(function () {
      component.search_timeout = undefined;
      component.setState({
        ['delayed_' + name]: value
      });
    }, 320);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const can__export = isTrue(app.state.session?.user?.can_export_data);
    let filters = {
      start_date: state.start_date,
      end_date: state.end_date,
      payment_status: 'paid'
    };
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Export des commandes"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, can__export ? /*#__PURE__*/React.createElement("div", {
      className: "dashboard-right"
    }, /*#__PURE__*/React.createElement(Button, {
      href: '/export/commande?start_date=' + (state.start_date || '') + '&end_date=' + (state.end_date || ''),
      className: bemit('c-flat-btn', ['primary']),
      target: "_blank",
      component: Link
    }, "Exporter les commandes")) : undefined, /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--users"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['start_date'] || "",
      className: "cutom-date-picker",
      name: "start_date",
      label: "Date de commande (d\xE9but)",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['end_date'] || "",
      className: "cutom-date-picker",
      name: "end_date",
      label: "Date de commande (fin)",
      "allow-no-value": true,
      status: state.status_messages
    }))), /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table u-margin-bottom-25",
      style: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-paper u-padding-top-0\r no-horizontal-padding"
    }, /*#__PURE__*/React.createElement(Dashboard, {
      model: "PackOrder",
      url: action('getAllPackOrders'),
      header: header,
      fields: fields,
      component: PackOrderRow,
      "items-per-page": 30,
      filters: filters
    })))));
    return output;
  }
}
